module.exports = __webpack_public_path__ + "static/media/lid-margin-dark.255f083f.png";